import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { MediaType } from 'enums/media'
import { ICarouseItem } from 'interfaces/listing'
import { IMedia } from 'interfaces/media'
import { IRoomDefaultValue } from 'interfaces/roomDefaultValue'
import { formatAvailableDate, getValidArray } from 'utils/common'
dayjs.extend(advancedFormat)

export function getAvailableDateInRoomCard(defaultRoomValue?: IRoomDefaultValue, houseAvailableDate?: Date): string {
  const NOW_AVAILABLE_DATE_LABEL: string = 'Now'
  const today: Date = new Date()
  let startDate: Date | null = null
  let endDate: Date | null = null

  if (houseAvailableDate && dayjs(houseAvailableDate).isAfter(today)) {
    startDate = houseAvailableDate
    endDate = dayjs(houseAvailableDate).add(1, 'month').toDate()
  }

  if (!startDate && !endDate) {
    startDate = dayjs(defaultRoomValue?.availableStartDate).toDate()
    endDate = dayjs(defaultRoomValue?.availableEndDate).toDate()
  }

  const formattedStartDate: string = formatAvailableDate(startDate!)
  const formattedEndDate: string = formatAvailableDate(endDate!)

  if (formattedStartDate === NOW_AVAILABLE_DATE_LABEL || formattedEndDate === NOW_AVAILABLE_DATE_LABEL) {
    return NOW_AVAILABLE_DATE_LABEL
  }

  return formattedStartDate
}

export function getImageMediaUnit(media: IMedia[]): ICarouseItem[] {
  return getValidArray(media)
    ?.filter((mediaDetail: IMedia) => mediaDetail.type === MediaType.IMAGE)
    ?.sort((mediaItemA: IMedia, mediaItemB: IMedia) => (mediaItemA?.unitOrder ?? 0) - (mediaItemB?.unitOrder ?? 0))
    ?.map((mediaDetail: IMedia) => ({
      name: mediaDetail.name,
      url: mediaDetail.url ?? mediaDetail?.buildiumUrl
    }))
}
